import type { Nullable } from '@evc/web-components';

export type ApiPaginatedResult<T> = {
  items: T[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  /** used only for back office */
  continuationToken?: Nullable<string>;
};

export type ApiResponse<T> = {
  correlationId: string;
  requestId: string;
  result: T;
  errors?: null;
};
export type ApiResponseError = {
  correlationId: string;
  requestId: string;
  result: null;
  errors: ApiErrorItem[];
};

export type HttpError = {
  error: ApiResponseError;
  headers: unknown;
  message: string;
  name: string;
  ok: boolean;
  status: number;
  statusText: string;
  url: string;
};

export type ValidationError = {
  propertyName: string;
  message: string;
  type: string;
};

// TODO list all
export type UnprocessableErrorType = 'Conflict' | 'Unknown';
export type UnprocessableError = {
  message: string;
  type: UnprocessableErrorType;
};

export type InternalError = {
  message: string;
  type?: string;
};

export type ApiErrorItem = ValidationError | UnprocessableError | InternalError;

export enum HttpCode {
  OK = 200,
  BadRequest = 400,
  Unauthorized = 401,
  UnprocessableEntity = 422,
  InternalServerError = 500,
  GatewayError = 502,
  Forbidden = 403,
}
